
export const environment = {
  production: false,
  name: "QA",

  auth0: {
    domain: 'transnetyx-qa.us.auth0.com',
    clientId: '3qlAM0z8EPexSkURbtS4dlVKuS6JlQ8T',
    audience: 'BioSeq_Api',
    scope: '',
    redirectUri: `https://bioseq-qa.transnetyx.com`
  },

  apiUrl: "https://apionprem-qa.transnetyx.com/bioseq/"
};
